import { createStore } from 'ice';
import app from './models/app';

const store = createStore({
  app,
}, {});

export default store;
